import { supabase } from '../supabase/supabase';

export const fetchAdminOrdersWithRefunds = async () => {
  const { data, error } = await supabase.rpc(
    'admin_get_all_orders_with_refunds_1793055000000'
  );

  if (error) throw error;

  return data || [];
};
